import { render, staticRenderFns } from "./BaseCardAction.vue?vue&type=template&id=d6a3ed34"
import script from "./BaseCardAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCardAction.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports